__turbopack_context__.v({
  "header": "EJXsxq_header",
  "message": "EJXsxq_message",
  "shimmer": "EJXsxq_shimmer",
  "subtitle": "EJXsxq_subtitle",
  "text-bar-sweep": "EJXsxq_text-bar-sweep",
  "title": "EJXsxq_title",
});
